import type { Service, VisitLine } from '@360face/domain';

/**
 * Minutes the therapist adds on the tablet beyond what was booked: for every service, the
 * quantity above the ordered one times its catalogue duration. Products, gifts and services
 * the catalogue does not know (e.g. CRM-only services) count as 0 minutes.
 */
export function addedMinutes(
  lines: readonly Pick<VisitLine, 'serviceId' | 'ordered'>[],
  quantities: Record<string, number>,
  catalog: readonly Pick<Service, 'id' | 'durationMin'>[],
): number {
  return Object.entries(quantities).reduce((sum, [id, q]) => {
    const ordered = lines.find((l) => l.serviceId === id)?.ordered ?? 0;
    const duration = catalog.find((s) => s.id === id)?.durationMin ?? 0;
    return sum + Math.max(0, q - ordered) * duration;
  }, 0);
}

/** A warning is due when added minutes exceed the free time (null = no next booking). */
export function exceedsFreeTime(added: number, freeMinutes: number | null | undefined): boolean {
  return added > 0 && typeof freeMinutes === 'number' && added > freeMinutes;
}
